import React, { useEffect, useMemo, useState } from 'react';
import { Tag, Popover as ArcoPopover } from '@arco-design/web-react';
import { NumberInput } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import './index.scss';

export const ExcludePromptItem = '__lora_emhance__';

const PromptItem = (props) => {
  const { value = '', onClose, index, onScaleChange } = props || {};
  let initScale = 1;
  let checkedValue = value;
  if (/\(/.test(value)) {
    initScale = parseFloat((value.match(/\d+\.\d+/) || [])[0]);
    const _val = (value.match(/\(([^:]+):/) || [])[1];
    if (_val) {
      checkedValue = _val;
    }
  }
  const [scale, setScale] = useState(initScale);
  useEffect(() => {
    if (initScale) {
      setScale(initScale);
    }
  }, [initScale]);
  const handleInputScaleChange = (val) => {
    const validVal = Number(Number(val).toFixed(1));
    // onScaleChange?.(index, value, validVal);
    setScale(validVal);
  };
  const text = useMemo(() => {
    return `(${checkedValue}: ${scale.toFixed(1)})`;
  }, [checkedValue, scale]);

  const keyStr = useMemo(() => {
    const key = value.replace(/\d+\.\d+/g, '').replace(/[():\s]+/g, '');
    console.log('keyStr', key);
    return key;
  }, [value]);

  const handleVisibleChange = (visible) => {
    if (!visible && scale > 0) {
      onScaleChange?.(index, value, scale);
    }
  };

  return (
    <ArcoPopover
      title={null}
      trigger={['hover']}
      triggerProps={{
        popupAlign: {
          top: [0, -1],
        },
      }}
      onVisibleChange={handleVisibleChange}
      onClick={(e) => e.stopPropagation()}
      key={keyStr}
      className={'prompt-popover'}
      content={
        <div className="prompt-text-popup" onClick={(e) => e.stopPropagation()}>
          <NumberInput
            min={0.1}
            leftSection={
              <span style={{ display: 'inline-block', width: '78px', color: '#000' }}>
                {translate('prompt_weight')}
              </span>
            }
            decimalScale={1}
            fixedDecimalScale
            className={'prompt-input-numbers out'}
            max={3}
            value={scale}
            step={0.1}
            onChange={handleInputScaleChange}
            style={{ width: '100px', height: '26px' }}
          />
          {/* <InputNumber
            min={0}
            value={scale}
            prefix="权重"
            className={'prompt-input-number'}
            max={1}
            step={0.01}
            onChange={handleInputScaleChange}
            style={{ width: '82px', height: '26px' }}
          /> */}
        </div>
      }
    >
      <Tag
        color="#fff"
        className="tips-in-tag"
        // onMouseEnter={() => setHoverIdx(index)}
        closable={true}
        onClose={onClose}
        style={{ height: 'auto', minHeight: '28px', marginRight: '8px', marginBottom: '8px' }}
      >
        <span className="text-xs text-[#7F7F7F] font-normal whitespace-break-spaces">{text}</span>
      </Tag>
    </ArcoPopover>
  );
};

export default PromptItem;
